export const ARTICULOS_ACTION_TYPES = {
  SET_ARTICULOS: "asignar/SET_ARTICULOS",
  SET_ARTICULOS_ERRORES: "asignar/SET_ARTICULOS_ERRORES",
  SET_ES_AGREGAR_ARTICULOS_ABIERTO: "asignar/SET_ES_AGREGAR_ARTICULOS_ABIERTO",
  SET_HABILITAR_BOTON: "asignar/SET_HABILITAR_BOTON",
};
